import { useEffect } from 'react'

export function useScreenWakeLock() {
  useEffect(() => {
    if (!navigator.wakeLock) return
    let sentinel: WakeLockSentinel | null = null
    let cancelled = false
    let requesting = false

    const acquire = async () => {
      if (cancelled || requesting || (sentinel && !sentinel.released) || document.visibilityState !== 'visible') return
      requesting = true
      try {
        const lock = await navigator.wakeLock.request('screen')
        if (cancelled || document.visibilityState !== 'visible') {
          await lock.release()
          return
        }
        sentinel = lock
        lock.addEventListener(
          'release',
          () => {
            if (sentinel === lock) sentinel = null
          },
          { once: true },
        )
      } catch {
        // Unsupported policy or low battery: retry when the page is visible again.
      } finally {
        requesting = false
      }
    }

    const onVisible = () => {
      if (document.visibilityState === 'visible') acquire()
    }
    acquire()
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      cancelled = true
      document.removeEventListener('visibilitychange', onVisible)
      sentinel?.release().catch(() => {})
    }
  }, [])
}
